declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: Record<string, string> }) => void;
  }
}

export function trackEvent(name: string, props?: Record<string, string>): void {
  if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
    window.plausible(name, { props });
  }
}

// The Company Page. LinkedIn's own first-listed advice for getting followers
// is a follow link on your own site and newsletters, and for an anonymous
// brand page it is the only acquisition channel that needs no scope, no ToS
// surface and no personal profile. Kept here so every placement uses the same
// URL and the same event name.
export const LINKEDIN_PAGE_URL = 'https://www.linkedin.com/company/fsnu/';

export function trackFollowClick(placement: string): void {
  trackEvent('linkedin_follow_click', { placement });
}
